
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-12">
          {/* Logo & description */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-3 sm:mb-4">
              <img
                src="https://static.readdy.ai/image/9e7578784cafb125cff30a4f31132a63/ad27ada49540da22387d47bc2e323587.png"
                alt="Tulaura"
                className="h-10 sm:h-12 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
              Le concours qui révèle les talents entrepreneuriaux et transforme les idées en succès.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              <a
                href="https://t.me/+3ecXNoeoPVg4MjJk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-full transition-colors cursor-pointer"
                aria-label="Telegram"
              >
                <i className="ri-telegram-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/tulaura_officiel/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-full transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://www.tiktok.com/@tulaura_off?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-full transition-colors cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://x.com/tulaura_off"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-secondary rounded-full transition-colors cursor-pointer"
                aria-label="X (Twitter)"
              >
                <i className="ri-twitter-x-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Navigation</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/comment-ca-marche"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Comment ça marche
                </Link>
              </li>
              <li>
                <Link
                  to="/registration"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Participer
                </Link>
              </li>
              <li>
                <Link
                  to="/reglement"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Règlement
                </Link>
              </li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Légal</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/politique-confidentialite"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/conditions"
                  className="text-gray-400 hover:text-secondary transition-colors text-xs sm:text-sm"
                >
                  Conditions d&apos;utilisation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Contact</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-center gap-2 sm:gap-3 text-gray-400 text-xs sm:text-sm">
                <i className="ri-mail-line text-secondary flex-shrink-0"></i>
                <a
                  href="mailto:contact@tulaura.com"
                  className="hover:text-secondary transition-colors break-all"
                >
                  contact@tulaura.com
                </a>
              </li>
              <li className="flex items-center gap-2 sm:gap-3 text-gray-400 text-xs sm:text-sm">
                <i className="ri-telegram-line text-secondary flex-shrink-0"></i>
                <a
                  href="https://t.me/+3ecXNoeoPVg4MjJk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors"
                >
                  Rejoindre Telegram
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom separator and copyright */}
        <div className="border-t border-gray-700 mt-8 sm:mt-12 pt-6 sm:pt-8 text-center">
          <p className="text-gray-400 text-xs sm:text-sm mb-1">© 2024 Tulaura. Tous droits réservés.</p>
          <p className="text-xs">Adventure Universe LTD, société enregistrée au Royaume-Uni.</p>
        </div>
      </div>
    </footer>
  );
}
